import React from 'react';
import { ALL_RISK_TIER_NUMBERS, TIER_CATALOG } from '../../tiers/tierCatalog';
import TierChip from './TierChip';

const TierSpectrumExplainer: React.FC = () => (
  <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
    <h3 className="text-sm font-semibold text-gray-900">Six-tier framework</h3>
    <p className="mt-1 text-sm text-gray-600">
      Marlin partitions one account into independent objectives. Today you can enable
      Tier 1 (macro ETF) and Tier 6 (options orchestrator); tiers 2–5 preview the
      full spectrum.
    </p>
    <ul className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {ALL_RISK_TIER_NUMBERS.map((n) => {
        const c = TIER_CATALOG[n];
        const live = n === 1 || n === 6;
        return (
          <li
            key={n}
            className={`rounded-lg border p-3 ${live ? 'border-primary-200 bg-primary-50/40' : 'border-gray-100 bg-gray-50/50'}`}
          >
            <TierChip riskTier={n} variant={live ? 'default' : 'inactive'} />
            <p className="mt-2 text-xs font-medium text-gray-900">{c.name}</p>
            <p className="mt-1 text-xs text-gray-600">{c.focus}</p>
            {!live ? (
              <p className="mt-2 text-[10px] font-medium uppercase tracking-wide text-gray-400">
                Coming soon
              </p>
            ) : null}
          </li>
        );
      })}
    </ul>
  </div>
);

export default TierSpectrumExplainer;
